import { render, staticRenderFns } from "./AppTemplateApply.vue?vue&type=template&id=56e413c2&scoped=true&"
import script from "./AppTemplateApply.vue?vue&type=script&lang=js&"
export * from "./AppTemplateApply.vue?vue&type=script&lang=js&"
import style0 from "./AppTemplateApply.vue?vue&type=style&index=0&id=56e413c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e413c2",
  null
  
)

export default component.exports